export function hasPermission(
  pagePath,
  buttonCode
) {

  const buttonMap = JSON.parse(
    sessionStorage.getItem("buttonMap")
  ) || {};

  const perms =
    buttonMap[pagePath] || [];

  return perms.includes(buttonCode);

}



// WEBPACK FOOTER //
// ./src/utils/permission.js